<section class="main-content wrapper content-padding" style="margin-top: 50px">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">Promemoria attività partner</a>
      </label>
    </div>

    <div class="item nowrap">
      <span class="btn-container top-button-container"></span>
    </div>

    <hr class="gold-hr" />

    <section class="main-content wrapper">
      <div class="settings-page">
        <div class="page-header">
          <div>
            <h1>Promemoria attività partner</h1>
            <p>
              Configura il riepilogo giornaliero delle attività di consegna da
              inviare ai partner.
            </p>
          </div>
        </div>

        <div *ngIf="loading || !form" class="loading-box">
          Caricamento impostazioni...
        </div>

        <form
          *ngIf="!loading && form"
          [formGroup]="form"
          class="settings-card"
          (ngSubmit)="save()"
        >
          <div class="toggle-row">
            <div>
              <label class="main-label"> Abilita promemoria giornalieri </label>

              <p>
                Invia ai partner un riepilogo giornaliero delle attività di
                consegna imminenti.
              </p>
            </div>

            <label class="switch">
              <input type="checkbox" formControlName="enabled" />
              <span></span>
            </label>
          </div>

          <div class="form-content" [class.disabled]="!enabled">
            <div class="grid three">
              <div class="field">
                <label>Orario promemoria</label>

                <input type="time" formControlName="reminderTime" />

                <small
                  class="error"
                  *ngIf="
                    form.get('reminderTime')?.touched &&
                    form.get('reminderTime')?.invalid
                  "
                >
                  L'orario del promemoria è obbligatorio.
                </small>
              </div>

              <div class="field">
                <label>Fuso orario</label>

                <select formControlName="timezone">
                  <option *ngFor="let timezone of timezones" [value]="timezone">
                    {{ timezone }}
                  </option>
                </select>

                <small
                  class="error"
                  *ngIf="
                    form.get('timezone')?.touched &&
                    form.get('timezone')?.invalid
                  "
                >
                  Il fuso orario è obbligatorio.
                </small>
              </div>

              <div class="field">
                <label>Giorni da includere</label>

                <input
                  type="number"
                  min="1"
                  max="30"
                  formControlName="daysAhead"
                />

                <small
                  class="error"
                  *ngIf="
                    form.get('daysAhead')?.touched &&
                    form.get('daysAhead')?.invalid
                  "
                >
                  Il numero di giorni deve essere compreso tra 1 e 30.
                </small>
              </div>
            </div>

            <div class="field status-field">
              <label>Stati delle consegne da includere</label>

              <div class="status-grid">
                <label
                  class="status-option"
                  *ngFor="let status of deliveryStatuses"
                  [class.selected]="isStatusSelected(status.value)"
                >
                  <input
                    type="checkbox"
                    [checked]="isStatusSelected(status.value)"
                    (change)="toggleStatus(status.value)"
                  />

                  <span>{{ status.label }}</span>
                </label>
              </div>

              <small
                class="error"
                *ngIf="
                  form.get('statuses')?.touched &&
                  enabled &&
                  form.get('statuses')?.value?.length === 0
                "
              >
                Seleziona almeno uno stato della consegna.
              </small>
            </div>

            <div class="grid one">
              <div class="field">
                <label>Oggetto email</label>

                <input
                  type="text"
                  formControlName="subject"
                  placeholder="Riepilogo attività"
                />

                <small
                  class="error"
                  *ngIf="
                    form.get('subject')?.touched && form.get('subject')?.invalid
                  "
                >
                  L'oggetto dell'email è obbligatorio.
                </small>
              </div>
            </div>
          </div>

          <div class="message success" *ngIf="successMessage">
            {{ successMessage }}
          </div>

          <div class="message error-message" *ngIf="errorMessage">
            {{ errorMessage }}
          </div>

          <div class="actions">
            <button type="submit" [disabled]="saving">
              {{ saving ? "Salvataggio..." : "Salva impostazioni" }}
            </button>
          </div>
        </form>
      </div>
    </section>
  </div>
</section>
